import { Outlet } from '@tanstack/react-router';
import { LiveRegion } from '../components/LiveRegion.tsx';

export function RootLayout() {
  return (
    <>
      <Outlet />
      <LiveRegion />
    </>
  );
}
